module.exports = __webpack_public_path__ + "static/media/iwa_logo.c5db21cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/iwa_logo.svg
// module id = 173
// module chunks = 0